import { ComponentIds } from "@inter-ikea-core/core";
import { BROR as appId } from "./constants";
import storedCatalog from "./rangeConfig/catalog.json";
import storedTemplates from "./rangeConfig/template.json";
import { RangeApi } from "@inter-ikea-storagetwo/range/dist/rangeApi";
import * as stability from "@inter-ikea-storagetwo/range/dist/functions/stability";
import { getCatalogAndTemplate } from "@inter-ikea-storagetwo/range/dist/utils/catalogAndTemplateUtils";
import OrganizersComponent from "@inter-ikea-storagetwo/range/dist/components/OrganizerLimitComponent";
import { components } from "./components";
import { systemsDefinitionList } from "./systems";
import { validations } from "./validations";
import { Segment } from "@inter-ikea-storagetwo/dexf-utils";
export class Bror extends RangeApi {
    constructor({ core, env = Segment.production, catalogAndTemplate, }) {
        const { catalog, templates } = getCatalogAndTemplate(catalogAndTemplate, storedCatalog, storedTemplates);
        super({
            core,
            systemsDefinitionList,
            templates,
            catalog,
            env,
            appId,
            components,
            validations,
        });
    }
    init({ viewer, viewerCoreAdapter }) {
        super.init({ viewer, viewerCoreAdapter });
        this.core.services.productManager.subscribeProductCreated((entity) => {
            var _a, _b;
            const isStackableOrganizer = (_b = (_a = entity.getComponent(ComponentIds.META_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.metaData) === null || _b === void 0 ? void 0 : _b.stack;
            if (isStackableOrganizer) {
                entity.addComponent(new OrganizersComponent());
            }
        });
    }
}
export { Bror as default, stability };
